import { useCallback, useState } from 'react';
import styled from 'styled-components';
import UIPopover from 'UIComponents/tooltip/UIPopover';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import { useSettingsOmnibusContext } from '../contexts/SettingsOmnibusContext';
import { CallFromNumberContextProvider } from '../contexts/CallFromNumberContext';
import ReturnCallPopover from './ReturnCallPopover';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledUIPopover = styled(UIPopover).withConfig({
  displayName: "ReturnCallButton__StyledUIPopover",
  componentId: "sc-1gsxk4n-0"
})(["top:'auto';&&{padding:0;}.uiPopoverBody{padding:0 !important;}"]);
const ReturnCallButton = ({
  callId,
  inboundCallDestinationPhoneNumber,
  inboundCallOriginPhoneNumber,
  setCallStarted
}) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const {
    settingsOmnibus
  } = useSettingsOmnibusContext();
  const handlePopoverToggle = useCallback(() => {
    setIsPopoverOpen(!isPopoverOpen);
  }, [isPopoverOpen]);
  return /*#__PURE__*/_jsx(CallFromNumberContextProvider, {
    inboundCallDestinationPhoneNumber: inboundCallDestinationPhoneNumber,
    settingsOmnibus: settingsOmnibus,
    children: /*#__PURE__*/_jsx(StyledUIPopover, {
      open: isPopoverOpen,
      onOpenChange: handlePopoverToggle,
      content: {
        body: /*#__PURE__*/_jsx(ReturnCallPopover, {
          callId: callId,
          inboundCallOriginPhoneNumber: inboundCallOriginPhoneNumber,
          onClosePopover: handlePopoverToggle,
          setCallStarted: setCallStarted
        })
      },
      placement: "bottom right",
      children: /*#__PURE__*/_jsx(UIIconButton, {
        shape: "circle",
        tooltip: "Return Call",
        placement: "top",
        onClick: handlePopoverToggle,
        children: /*#__PURE__*/_jsx(UIIcon, {
          name: "calling"
        })
      })
    })
  });
};
export default ReturnCallButton;